<template lang="pug">

	.lesson-block.-ov-hid-.main-block
		img.lesson-block__image(:src="content.img.url")


</template>

<script>
export default {
  props: {
    content: {}
  }
};
</script>
